import { MdVerifiedUser, MdGavel, MdLoop } from "react-icons/md";
import { IoShieldCheckmarkOutline } from "react-icons/io5";

const PPEPolicy = () => {
  const policies = [
    "Selected personal protective equipment must be in line with National Legislation/Standards and other appropriate international standards;",
    "Management shall provide personnel with appropriate uniform and personal protective equipment for each task, activity and area at no cost to the personnel after having carried out a risk assessment;",
    "Employee shall sign for all uniform and personal protective equipment received except for those that are disposable;",
    "Heads of Department shall be responsible for enforcing the use of the appropriate personal protective equipment;",
    "Contractors and visitors must conform to our Personal Protective Equipment Policy in areas of our facilities where it is required. They shall be provided with adequate information and direction to ensure their safety;",
    "Every employee shall be responsible for the use of appropriate personal protective equipment;",
    "Management shall replace uniforms and other personal protective equipment at specified frequency;",
    "Any employee found violating the use of appropriate uniform and personal protective equipment will face disciplinary action;",
    "The structure and responsibilities for the implementation of this policy shall be available for reference by all employees as required;",
    "Personal Protective Equipment shall be audited periodically for compliance;",
    "The implementation of this policy shall be monitored and reviewed as necessary by Company HSE Manager to ensure its relevance and effectiveness."
  ];

  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Hero Section */}
      <div className="relative bg-[#14532d] text-white py-6 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
              PPE <span className="text-yellow-400">Policy</span>
              </h2>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mt-2 mb-0"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 md:py-6">
        {/* Intro Card */}
        <div className="bg-black text-white p-4 sm:p-6 md:p-8 mb-4 shadow-xl rounded-xl md:rounded-2xl border-l-[6px] md:border-l-[8px] border-green-700 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/10 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed font-bold relative z-10 mb-2 italic">
            BEDC Electricity Plc is committed to the health and safety of all employees, contractors and visitors at its facilities.
          </p>
          <p className="text-gray-400 font-medium text-xs sm:text-sm relative z-10 leading-relaxed">
            Employees are provided PPEs when hired, and instructed on proper use and care. Employees are responsible for keeping PPEs in good working condition and are expected to notify their supervisors if any PPE no longer meets safety standards.
          </p>
        </div>

        {/* Policy Guidelines Card */}
        <div className="bg-white rounded-xl md:rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="bg-[#14532d] px-5 sm:px-6 py-4 flex items-center gap-3">
            <div className="bg-yellow-400 p-2 rounded-lg shadow-md">
              <MdVerifiedUser className="text-xl sm:text-2xl text-black" />
            </div>
            <h2 className="text-white text-base sm:text-lg md:text-xl font-black uppercase tracking-tighter">
              Policy Guidelines
            </h2>
          </div>

          <div className="p-4 sm:p-6 md:p-8">
            <div className="grid grid-cols-1 gap-2.5 sm:gap-3">
              {policies.map((policy, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-lg bg-gray-50 border border-transparent hover:border-green-700 hover:bg-white transition-all duration-300 group"
                >
                  <div className="mt-0.5 flex-shrink-0 bg-white p-1.5 rounded-md shadow-sm group-hover:bg-green-700 transition-colors">
                    <IoShieldCheckmarkOutline className="text-green-700 text-base sm:text-lg group-hover:text-white" />
                  </div>

                  <p className="text-black font-medium leading-relaxed text-xs sm:text-sm md:text-base">
                    {policy}
                  </p>
                </div>
              ))}
            </div>

            {/* Policy Footer / Disclaimer */}
            <div className="mt-6 sm:mt-8 grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 pt-4 border-t border-gray-100">
              <div className="flex items-center gap-2.5 text-black font-black uppercase text-[10px] sm:text-[11px] tracking-widest">
                <div className="bg-yellow-400 p-1.5 rounded-md flex-shrink-0">
                  <MdGavel className="text-base sm:text-lg" />
                </div>
                <span>Violations are subject to disciplinary action.</span>
              </div>
              <div className="flex items-center gap-2.5 text-black font-black uppercase text-[10px] sm:text-[11px] tracking-widest md:justify-end">
                <div className="bg-green-700 text-white p-1.5 rounded-md flex-shrink-0">
                  <MdLoop className="text-base sm:text-lg" />
                </div>
                <span>Monitored & reviewed by HSE Manager.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PPEPolicy;